import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Grid, Header, Icon, List } from 'semantic-ui-react';
import { DosageDto, MedicamentDosage } from 'ts-types/api.types';
import styled from 'styled-components';

const WrapperGridDosage = styled(Grid)`
  &.ui.grid {
    margin-left: 1rem;
  }
`;

const StyledListItem = styled(List.Item)`
  color: rgba(0,0,0,.87) !important;
`;

const StyledHeaderRow = styled(Grid.Row)`
    margin-top: 1rem !important;
`;

const StyledIcon = styled(Icon)`
  cursor: pointer;
`;

const StyledBorderColumn = styled(Grid.Column)`
     border-bottom: 1px solid rgba(34,36,38,.1);
`;

const StyledDosageBtnContainer = styled.div`
  margin-bottom: 5px;
`;

interface Props extends MessageSourceProps {
  dosage?: Array<DosageDto>,
  medicamentDosage: Array<Partial<MedicamentDosage>>,
  passMedDosage: (medicamentDosage: Array<Partial<MedicamentDosage>>) => void
}

interface State {
  dosage?: Array<DosageDto>,
  medicamentDosage?: Array<Partial<MedicamentDosage>>,
  selectedAddDosage?: Array<Partial<DosageDto>>,
  selectedRemoveDosage?: Array<Partial<DosageDto>>
}

class MedicamentDosageSegment extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const {medicamentDosage = [], dosage = []} = this.props;

    this.state = {
      dosage: dosage,
      medicamentDosage: medicamentDosage,
      selectedAddDosage: [],
      selectedRemoveDosage: []
    };
  }

  markAddDosage = (dosageId: number) => {

    const {dosage, selectedAddDosage} = this.state;
    const foundDosage = dosage!.find((dose) => dose.id === dosageId);

    if (selectedAddDosage && selectedAddDosage.length > 0) {

      if (foundDosage) {
        selectedAddDosage.push(foundDosage);
        this.setState({
          selectedAddDosage: selectedAddDosage,
          selectedRemoveDosage: [],
        });

      }

    } else {

      if (foundDosage) {

        this.setState({
          selectedAddDosage: [foundDosage],
          selectedRemoveDosage: [],
        });

      }
    }
  };

  unmarkAddDosage = (dosageId: number) => {

    const {selectedAddDosage} = this.state;

    const dosageIndex = selectedAddDosage ? selectedAddDosage.findIndex((dosage) => {
      return dosage.id === dosageId;
    }) : null;

    if (selectedAddDosage && dosageIndex !== null) {

      selectedAddDosage.splice(dosageIndex, 1);
      this.setState({
        selectedAddDosage: selectedAddDosage,
      });

    }
  };

  markRemoveDosage = (dosageId: number) => {

    const {dosage, selectedRemoveDosage} = this.state;
    const foundDosage = dosage!.find((dose) => dose.id === dosageId);

    if (selectedRemoveDosage && selectedRemoveDosage.length > 0) {

      if (foundDosage) {
        selectedRemoveDosage.push(foundDosage);
        this.setState({
          selectedAddDosage: [],
          selectedRemoveDosage: selectedRemoveDosage,
        });
      }
    } else {

      if (foundDosage) {
        this.setState({
          selectedAddDosage: [],
          selectedRemoveDosage: [foundDosage],
        });
      }

    }
  };

  unmarkRemoveDosage = (dosageId: number) => {

    const {selectedRemoveDosage} = this.state;

    const dosageIndex = selectedRemoveDosage ? selectedRemoveDosage.findIndex((dosage) => {
      return dosage.id === dosageId;
    }) : null;

    if (selectedRemoveDosage && dosageIndex !== null) {

      selectedRemoveDosage.splice(dosageIndex, 1);
      this.setState({
        selectedRemoveDosage: selectedRemoveDosage,
      });

    }

  };

  addDosage = () => {

    const {passMedDosage} = this.props;
    const {medicamentDosage, selectedAddDosage} = this.state;

    if (selectedAddDosage) {
      const newDosage: Array<Partial<MedicamentDosage>> = medicamentDosage ? medicamentDosage : [];
      selectedAddDosage.map((dosage) => {
        newDosage.push({
          dosageId: dosage.id,
        })
      });

      this.setState({
        medicamentDosage: newDosage,
        selectedAddDosage: [],
        selectedRemoveDosage: [],
      });
      passMedDosage(medicamentDosage!);

    }

  };

  addAllDosage = () => {

    const {dosage} = this.state;

    const allDosages = dosage ? dosage : [];

    this.setState({
      selectedAddDosage: [...allDosages],
      selectedRemoveDosage: [],
    });

  };

  removeDosage = () => {

    const {passMedDosage} = this.props;
    const {medicamentDosage, selectedRemoveDosage} = this.state;

    if (medicamentDosage && selectedRemoveDosage) {

      for (let i = medicamentDosage.length - 1; i >= 0; i--) {
        for (let j = 0; j < selectedRemoveDosage.length; j++) {
          if (medicamentDosage[i] && (medicamentDosage[i].dosageId === selectedRemoveDosage[j].id)) {
            medicamentDosage.splice(i, 1);
          }
        }
      }

      this.setState({
        medicamentDosage: [...medicamentDosage],
        selectedRemoveDosage: [],
        selectedAddDosage: [],
      });
      passMedDosage(medicamentDosage!);

    }
  };

  removeAllDosage = () => {

    const {medicamentDosage} = this.state;
    const allDosages: Array<Partial<DosageDto>> = [];

    medicamentDosage!.map((dosage) => {
      allDosages.push({id: dosage.dosageId})
    });

    this.setState({
      selectedAddDosage: [],
      selectedRemoveDosage: allDosages,
    });

  };

  unmarkAllDosages = () => {

    const {selectedAddDosage} = this.state;

    if (selectedAddDosage!.length > 0) {
      this.setState({
        selectedAddDosage: []
      });
    } else {
      this.setState({
        selectedRemoveDosage: []
      });
    }

  };

  render(): React.ReactNode {

    const {getMessage} = this.props;
    const {dosage, medicamentDosage, selectedAddDosage, selectedRemoveDosage} = this.state;

    const listDosages = dosage ? dosage.map((dos) => {
      const {selectedAddDosage} = this.state;

      const appliedDosage = medicamentDosage && medicamentDosage.find((medDosage) => {
        return medDosage.dosageId === dos.id
      });

      if (!appliedDosage) {
        return (
            <StyledListItem key={dos.id}
                            onClick={() => {
                              !(selectedAddDosage && selectedAddDosage.includes(dos)) ?
                                  this.markAddDosage(dos.id) :
                                  this.unmarkAddDosage(dos.id)
                            }}
                            active={selectedAddDosage && selectedAddDosage.includes(dos)}
            >
              {dos.description}
            </StyledListItem>
        );
      }
    }) : [];

    const medicamentDosages = dosage && dosage.map((dos) => {
      const {selectedRemoveDosage} = this.state;

      const appliedDosage = medicamentDosage && medicamentDosage.find((medDosage) => {
        return medDosage.dosageId === dos.id
      });

      if (appliedDosage) {

        let active = false;
        if (selectedRemoveDosage && selectedRemoveDosage.find((selected) => {
          return selected.id === dos.id;
        })) {
          active = true;
        }

        return (
            <StyledListItem key={dos.id}
                            onClick={() => {
                              !active ? this.markRemoveDosage(dos.id) : this.unmarkRemoveDosage(dos.id)
                            }}
                            active={active}
            >
              {dos.description}
            </StyledListItem>
        );
      }
    });

    return (
      <React.Fragment>
        <WrapperGridDosage>
          <StyledHeaderRow>
            <StyledBorderColumn width={16}>
              <Header as='h5'>
                {getMessage("medicament.dosage")}
              </Header>
            </StyledBorderColumn>
          </StyledHeaderRow>
          <Grid.Row>
            <Grid.Column width={6}>
              <Header as='h5'>
                {getMessage("medicament.available")}
              </Header>
              <List divided selection verticalAlign='middle'>
                {listDosages}
              </List>
            </Grid.Column>
            <Grid.Column width={4} textAlign='center' verticalAlign='middle'>
              <StyledDosageBtnContainer>
                <StyledIcon bordered
                            disabled={!(selectedAddDosage!.length > 0)}
                            onClick={this.unmarkAllDosages}
                            name='clipboard outline'
                />
                <StyledIcon bordered
                            disabled={!(selectedRemoveDosage!.length > 0)}
                            onClick={() => this.unmarkAllDosages()}
                            name='clipboard outline'
                />
              </StyledDosageBtnContainer>
              <StyledDosageBtnContainer>
                <StyledIcon bordered
                            disabled={medicamentDosage!.length === dosage!.length}
                            onClick={this.addAllDosage}
                            name='clipboard list'
                />
                <StyledIcon bordered
                            disabled={medicamentDosage!.length === 0}
                            onClick={this.removeAllDosage}
                            name='clipboard list'
                />
              </StyledDosageBtnContainer>
              <div>
                <StyledIcon bordered
                            disabled={!(selectedAddDosage!.length > 0)}
                            onClick={this.addDosage}
                            name='angle double right'
                />
                <StyledIcon bordered
                            disabled={!(selectedRemoveDosage!.length > 0)}
                            onClick={this.removeDosage}
                            name='angle double left'
                />
              </div>
            </Grid.Column>
            <Grid.Column width={6}>
              <Header as='h5'>
                {getMessage("medicament.applied")}
              </Header>
              <List divided selection verticalAlign='middle'>
                {medicamentDosages}
              </List>
            </Grid.Column>
          </Grid.Row>
        </WrapperGridDosage>
      </React.Fragment>
    );
  }

}

export default withMessages(MedicamentDosageSegment);
